import { call, put, SagaGenerator, takeLatest, takeMaybe } from "typed-redux-saga";
import { Action, AnyAction, Success } from "typescript-fsa";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { NEW_INSTANCE_IDENTIFIER } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { FormActivity } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Events } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";
import { TreeEngineActions } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";

import { getDocument } from "../../../utilities/rpcHelper";
import {
	TEXTBAUSTEINE_KATEGORIE_DOCUMENT,
	TEXTBAUSTEINE_TEXT_DOCUMENT
} from "../../../utilities/variables/documentModelName";

import { isDocumentWithCorrelatedFachverfahrenKey } from "../textbausteineTypeGuard";

export function* setCorrelatedFachverfahrenKeySaga(): SagaGenerator<void> {
	yield* takeLatest((action: AnyAction): boolean => {
		return (
			TreeEngineActions.event.match(action) &&
			Events.onInsertChildNodeRequest.done.match(action.payload.engineAction) &&
			!!action.payload.engineAction.payload.params.documentModelId &&
			isTextbausteinModel(action.payload.engineAction.payload.params.documentModelId)
		);
	}, setCorrelatedFachverfahrenKey);
}

function* setCorrelatedFachverfahrenKey(
	insertChildAction: Action<
		TreeEngineActions.EventPayload<
			Action<Success<Events.InsertChildNodeRequestPayload.Param, Events.InsertChildNodeRequestPayload.Result>>
		>
	>
): SagaGenerator<void> {
	const setDataAction = yield* takeMaybe((action: AnyAction): action is Action<ActivityActions.SetDataPayload> => {
		return (
			ActivityActions.setData.match(action) &&
			FormActivity.Data.SingleDocumentData.isInstance(action.payload.data) &&
			action.payload.data.document?.id === NEW_INSTANCE_IDENTIFIER &&
			isTextbausteinModel(action.payload.data.document?.modelId ?? "")
		);
	});

	if (!FormActivity.Data.SingleDocumentData.isInstance(setDataAction.payload.data)) {
		return;
	}

	const parentNode = insertChildAction.payload.engineAction.payload.params.insertPosition.target.nodeIdentifier;
	const parentDocument = yield* call(getDocument, parentNode.id);
	if (!parentDocument || !isDocumentWithCorrelatedFachverfahrenKey(parentDocument.document)) {
		return;
	}

	yield* put(
		ActivityActions.setData({
			...setDataAction.payload,
			data: {
				...setDataAction.payload.data,
				document: {
					...setDataAction.payload.data.document,
					root: {
						...setDataAction.payload.data.document.root,
						correlatedFachverfahrenKey: parentDocument.document.root.correlatedFachverfahrenKey
					}
				}
			}
		})
	);
}

function isTextbausteinModel(modelId: string): boolean {
	return [TEXTBAUSTEINE_KATEGORIE_DOCUMENT, TEXTBAUSTEINE_TEXT_DOCUMENT].includes(modelId);
}
